import { callApiToServer } from '../callApi';

export async function searchCard(
  authtoken,
  searchText,
  skipNumber,
  limitNumber,
  city,
  cardType,
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };

    let body = {
      search_text: searchText
  };
  
  if (city) {
      body.city = city;
  }

  if (cardType && cardType !== "all") {
      body.card_type = cardType;
  }
  
  body = JSON.stringify(body);
  
    let endUrl = "v1/auth/filter-card/" + skipNumber + "/" + limitNumber;
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
  }catch(err) {
    throw err;
  }
}
